class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.sectionElement = this.closest('[id^="shopify-section-"]');
    this.sectionId = this.sectionElement ? this.sectionElement.id.replace('shopify-section-', '') : 'main-search';
    this.searchWrapper = this.closest('.template-search__search');
    this.abortController = null;
    this.lastRenderedSearchParams = window.location.search.replace(/^\?/, '');
    this.debouncedRenderFromSyncedInput = debounce(() => {
      this.renderFromSearchTerm();
    }, 250);
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => {
      if (input.form) allSearchForms.push(input.form);
    });
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (this.input && this.input.form) {
      this.input.form.addEventListener('submit', this.onSubmit.bind(this));
    }
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onChange() {
    super.onChange();
    this.renderFromSearchTerm();
  }

  onSubmit(event) {
    event.preventDefault();
    this.renderFromSearchTerm();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
      this.renderFromSearchTerm();
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
    if (target !== this.input) {
      this.debouncedRenderFromSyncedInput();
    }
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }

  createSearchParamsFromInput() {
    const searchParams = new URLSearchParams(window.location.search);
    const query = this.input.value.trim();
    if (query.length) {
      searchParams.set('q', query);
      searchParams.set('options[prefix]', 'last');
    } else {
      searchParams.delete('q');
      searchParams.delete('options[prefix]');
    }
    searchParams.delete('page');
    return searchParams;
  }

  updateURL(searchParams) {
    const queryString = searchParams.toString();
    const nextUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}`;
    history.replaceState({ searchParams: queryString }, '', nextUrl);
  }

  renderFromSearchTerm() {
    if (!this.input) return;

    const searchParams = this.createSearchParamsFromInput();
    const searchParamsString = searchParams.toString();

    if (searchParamsString === this.lastRenderedSearchParams) return;
    this.lastRenderedSearchParams = searchParamsString;

    this.updateURL(searchParams);
    this.renderSection(searchParamsString);
  }

  renderSection(searchParamsString) {
    if (this.abortController) {
      this.abortController.abort();
    }

    if (this.searchWrapper) {
      this.searchWrapper.classList.add('is-loading');
    }

    this.abortController = new AbortController();
    const requestUrl = `${window.location.pathname}?section_id=${encodeURIComponent(this.sectionId)}${
      searchParamsString ? `&${searchParamsString}` : ''
    }`;

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Main search request failed with status ${response.status}`);
        }
        return response.text();
      })
      .then((htmlText) => {
        const parsedHTML = new DOMParser().parseFromString(htmlText, 'text/html');

        const newTemplateSearch = parsedHTML.querySelector('.template-search');
        const currentTemplateSearch = document.querySelector('.template-search');
        if (newTemplateSearch && currentTemplateSearch) {
          currentTemplateSearch.className = newTemplateSearch.className;
        }

        const newHeading = parsedHTML.querySelector('.template-search__header h1');
        const currentHeading = document.querySelector('.template-search__header h1');
        if (newHeading && currentHeading) {
          currentHeading.innerHTML = newHeading.innerHTML;
        }

        const newFilters = parsedHTML.getElementById('main-search-filters');
        const currentFilters = document.getElementById('main-search-filters');
        const currentGrid = document.getElementById('ProductGridContainer');
        if (newFilters && currentFilters) {
          currentFilters.innerHTML = newFilters.innerHTML;
        } else if (newFilters && !currentFilters && currentGrid && currentGrid.parentNode) {
          currentGrid.parentNode.insertBefore(newFilters, currentGrid);
        } else if (!newFilters && currentFilters) {
          currentFilters.remove();
        }

        const newGrid = parsedHTML.getElementById('ProductGridContainer');
        if (newGrid && currentGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
        } else if (!newGrid && currentGrid) {
          currentGrid.innerHTML = '';
        }

        const newStatus = parsedHTML.getElementById('TemplateSearchStatus');
        const currentStatus = document.getElementById('TemplateSearchStatus');
        if (newStatus && currentStatus) {
          currentStatus.innerHTML = newStatus.innerHTML;
        }

        const newProductCount = parsedHTML.getElementById('ProductCount');
        const currentProductCount = document.getElementById('ProductCount');
        if (newProductCount && currentProductCount) {
          currentProductCount.innerHTML = newProductCount.innerHTML;
        }

        const newProductCountDesktop = parsedHTML.getElementById('ProductCountDesktop');
        const currentProductCountDesktop = document.getElementById('ProductCountDesktop');
        if (newProductCountDesktop && currentProductCountDesktop) {
          currentProductCountDesktop.innerHTML = newProductCountDesktop.innerHTML;
        }

        if (this.searchWrapper) {
          this.searchWrapper.classList.remove('is-loading');
        }
      })
      .catch((error) => {
        if (this.searchWrapper) {
          this.searchWrapper.classList.remove('is-loading');
        }
        if (error?.name === 'AbortError' || error?.code === 20) return;
        console.error(error);
      });
  }
}

customElements.define('main-search', MainSearch);
